/**
 * MODULE: domain/pages/frontend/utils/pageKeyboardShortcutsUtils.ts
 * PURPOSE: Helpers for Pages keyboard shortcut guards and display labels
 */

export function isPagesShortcutsTypingTarget(el: Element | null): boolean {
  if (!el || !(el instanceof HTMLElement)) return false;
  if (el.isContentEditable || el.getAttribute('contenteditable') === 'true') return true;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}

export function isModKey(event: KeyboardEvent): boolean {
  return event.metaKey || event.ctrlKey;
}

export function modKeyLabel(): string {
  if (typeof navigator !== 'undefined' && /Mac|iPhone|iPad/i.test(navigator.platform)) {
    return '⌘';
  }
  return 'Ctrl';
}

export function formatModShortcut(key: string): string {
  return `${modKeyLabel()}+${key}`;
}
